import styled from 'styled-components';

export const TriggerButton = styled.button`
    position: relative;
    display: flex;
    align-items: center;
    gap: 0.5rem;
    transition: all 0.2s;
    background: none;
    border: none;
    cursor: pointer;
    outline: none;

    &:hover {
        opacity: 0.8;
    }
`;

export const IconContainer = styled.div`
    position: relative;
    width: 1.25rem;
    height: 1.25rem;
`;

export const SmallStar = styled.svg`
    position: absolute;
    width: 0.625rem;
    height: 0.625rem;

    &.top-right {
        top: 0;
        right: 0;
    }

    &.bottom-left {
        bottom: 0;
        left: 0;
    }
`;

export const TriggerLabel = styled.span`
    font-size: 0.875rem;
    font-weight: 500;
    color: ${({ theme }) => theme.colors.text.secondary};
    transition: color 0.2s;

    ${TriggerButton}:hover & {
        color: #0f3333;
    }
`;

export const PopoverBox = styled.div`
    position: relative;
    overflow: hidden;
    border-radius: 6px;
    background: ${({ theme }) => (theme.mode === 'dark' ? '#242a33' : '#f0f7ff')};
    padding: 1.25rem;
    box-shadow: ${({ theme }) => (theme.mode === 'dark'
    ? '0 20px 25px -5px rgba(255, 255, 255, 0.08), 0 10px 10px -5px rgba(255, 255, 255, 0.04)'
    : '0 20px 25px -5px rgba(224, 123, 45, 0.15), 0 10px 10px -5px rgba(224, 123, 45, 0.08)')};
    border: 2px solid ${({ theme }) => (theme.mode === 'dark' ? '#1a4d4d' : '#96c8c8')};
    width: 20rem;
    margin-top: 0.5rem;

    @keyframes slideIn {
        from {
            opacity: 0;
            transform: translateY(-8px);
        }
        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    animation: slideIn 0.2s ease-out;
`;

export const PopoverAnimatedGradient = styled.div`
    position: absolute;
    inset: 0;
    border-radius: 6px;
    opacity: 0.5;

    @keyframes gradientShift {
        0%, 100% {
            opacity: 0.3;
        }
        50% {
            opacity: 0.6;
        }
    }
`;

export const PopoverGradientInner = styled.div`
    position: absolute;
    inset: 0;
    background: linear-gradient(to right, #4d9e9e, #4d9e9e, #4d9e9e);
    filter: blur(4px);
    animation: gradientShift 3s ease-in-out infinite;
`;

export const PopoverContentInner = styled.div`
    position: relative;
    z-index: 10;
`;

export const PopoverHeader = styled.div`
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 0.75rem;
    margin-bottom: 0.75rem;
`;

export const PopoverHeaderLeft = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.75rem;
    flex: 1;
`;

export const PopoverIconWrapper = styled.div`
    flex-shrink: 0;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 6px;
    background: linear-gradient(to bottom right, #4d9e9e, #0f3333);
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 4px 6px -1px rgba(96, 165, 250, 0.2);
`;

export const PopoverTitle = styled.h3`
    font-size: 1rem;
    font-weight: 300;
    color: ${({ theme }) => theme.colors.text.primary};
    margin-bottom: 0.25rem;
`;

export const PopoverDescription = styled.p`
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.text.secondary};
    line-height: 1.5;
`;

export const CloseButton = styled.button`
    flex-shrink: 0;
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 6px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color 0.2s;
    background: none;
    border: none;
    cursor: pointer;
    outline: none;
    color: ${({ theme }) => theme.colors.text.secondary};

    &:hover {
        background-color: ${({ theme }) => (theme.mode === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(229, 231, 235, 0.5)')};
    }
`;

export const PopoverTipsList = styled.div`
    margin-top: 0.75rem;
    display: flex;
    flex-direction: column;
    gap: 0.5rem;
`;

export const PopoverTipItem = styled.div`
    display: flex;
    align-items: flex-start;
    gap: 0.5rem;
    font-size: 0.75rem;
    color: ${({ theme }) => theme.colors.text.primary};
`;

export const PopoverTipBullet = styled.div`
    width: 0.375rem;
    height: 0.375rem;
    border-radius: 9999px;
    background-color: #1a4d4d;
    margin-top: 0.25rem;
    flex-shrink: 0;
`;

export const PopoverDecorativeOrb = styled.div`
    position: absolute;
    top: -1.5rem;
    right: -1.5rem;
    width: 5rem;
    height: 5rem;
    background: linear-gradient(to bottom right, rgba(147, 197, 253, 0.15), rgba(165, 180, 252, 0.15));
    border-radius: 9999px;
    filter: blur(2rem);
`;
